import { type SxProps, type Theme } from "@mui/material";

import { mergeSx } from "ui/merge-sx";

/**
 * Figma paints both buttons in `primary.main`. Their glyph, their hover circle and the space around them
 * come from the field geometry on `MuiPickersOutlinedInput`, as on every field.
 */
export const OPEN_BUTTON_SX: SxProps<Theme> = (theme) => ({ color: theme.palette.primary.main });

/** MUI X hides the clear button until the field is hovered or focused; Figma shows it whenever it applies. */
export const CLEAR_BUTTON_SX: SxProps<Theme> = mergeSx(OPEN_BUTTON_SX, { "&.clearButton": { opacity: 1 } });
